module.exports = __webpack_public_path__ + "img/logo.ac22711b.png";